module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [(_vm.user.category === 2 || _vm.user.role === 3) ? _c('div', {
    staticClass: "row m-b-sm"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("所在部门：")]), _vm._v(" "), _vm._l((_vm.pids), function(parent, indexd) {
    return _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parent.selected),
        expression: "parent.selected"
      }],
      key: indexd,
      staticClass: "select input-sm m-r-xs",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          parent.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.selectParent($event, indexd)
        }]
      }
    }, _vm._l((parent.options), function(p) {
      return _c('option', {
        key: p._id,
        domProps: {
          "value": p._id
        }
      }, [_vm._v(_vm._s(p.name))])
    }))
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-sm btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.query
    }
  }, [_vm._v("查询")])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-title bg-success color-white"
  }, [_vm._v("数据概览")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 "
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.summary.inviteTotal))]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("邀请")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.summary.reportTotal))]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("报告")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.summary.inviteYesterday))]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("邀请")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.summary.reportYesterday))]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("报告")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-title bg-warning color-white"
  }, [_vm._v("每日趋势")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 m-t-b-xs"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-xs-12 input-sm text-right",
    staticStyle: {
      "line-height": "30px"
    }
  }, [_c('a', {
    staticClass: "color-info m-r-sm",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.last(7, _vm.daily)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('a', {
    staticClass: "color-info",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.last(30, _vm.daily)
      }
    }
  }, [_vm._v("最近30天")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9 col-sm-4"
  }, [_c('input', {
    staticClass: "input input-sm",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.daily.display
    },
    on: {
      "click": function($event) {
        _vm.openByDrop($event, _vm.daily)
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.daily.show) ? _c('div', {
    staticClass: "calendar-dropdown",
    style: ({
      'left': _vm.daily.left + 'px',
      'top': _vm.daily.top + 'px'
    })
  }, [_c('calendar', {
    attrs: {
      "range": _vm.daily.range,
      "zero": _vm.daily.zero,
      "lunar": _vm.daily.lunar,
      "value": _vm.daily.value,
      "begin": _vm.daily.begin,
      "end": _vm.daily.end
    },
    on: {
      "select": _vm.daily.select,
      "rangeStart": _vm.daily.rangeStart
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-sm-2 n-p-l"
  }, [_c('div', {
    staticClass: "btn btn-info btn-sm",
    on: {
      "click": _vm.buildDailyLine
    }
  }, [_vm._v("查询")])])])])])]), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-title bg-danger color-white"
  }, [_vm._v("能力群分布")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 m-t-b-xs"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12 text-right"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 col-xs-12 n-p-r"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ability.post),
      expression: "ability.post"
    }],
    staticClass: "select input-sm",
    attrs: {
      "name": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ability.post = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.buildAbilityBar]
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("全部岗位")]), _vm._v(" "), _vm._l((_vm.posts), function(post) {
    return _c('option', {
      key: post._id,
      domProps: {
        "value": post._id
      }
    }, [_vm._v(_vm._s(post.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-xs-12 input-sm n-p-r",
    staticStyle: {
      "line-height": "30px"
    }
  }, [_c('a', {
    staticClass: "color-info m-r-sm",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.last(7, _vm.ability)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('a', {
    staticClass: "color-info",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.last(30, _vm.ability)
      }
    }
  }, [_vm._v("最近30天")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9 col-sm-5"
  }, [_c('input', {
    staticClass: "input input-sm",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.ability.display
    },
    on: {
      "click": function($event) {
        _vm.openByDrop($event, _vm.ability)
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.ability.show) ? _c('div', {
    staticClass: "calendar-dropdown",
    style: ({
      'left': _vm.ability.left + 'px',
      'top': _vm.ability.top + 'px'
    })
  }, [_c('calendar', {
    attrs: {
      "range": _vm.ability.range,
      "zero": _vm.ability.zero,
      "lunar": _vm.ability.lunar,
      "value": _vm.ability.value,
      "begin": _vm.ability.begin,
      "end": _vm.ability.end
    },
    on: {
      "select": _vm.ability.select,
      "rangeStart": _vm.ability.rangeStart
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-sm-2 n-p-l"
  }, [_c('div', {
    staticClass: "btn btn-info btn-sm",
    on: {
      "click": _vm.buildAbilityBar
    }
  }, [_vm._v("查询")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row m-b-sm",
    staticStyle: {
      "height": "350px"
    },
    attrs: {
      "id": "ability-bar-charts"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ability.length >= 3),
      expression: "ability.length >= 3"
    }],
    staticClass: "row",
    staticStyle: {
      "height": "350px"
    },
    attrs: {
      "id": "ability-radar-charts"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-title bg-success color-white"
  }, [_vm._v("详细数据")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 m-t-b-xs"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12 text-right"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 col-xs-12 n-p-r"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.post),
      expression: "detail.post"
    }],
    staticClass: "select input-sm",
    attrs: {
      "name": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.detail.post = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.detailPostChange]
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("全部岗位")]), _vm._v(" "), _vm._l((_vm.posts), function(post) {
    return _c('option', {
      key: post._id,
      domProps: {
        "value": post._id
      }
    }, [_vm._v(_vm._s(post.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-xs-12 input-sm n-p-r",
    staticStyle: {
      "line-height": "30px"
    }
  }, [_c('a', {
    staticClass: "color-info m-r-sm",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.last(7, _vm.detail)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('a', {
    staticClass: "color-info",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.last(30, _vm.detail)
      }
    }
  }, [_vm._v("最近30天")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9 col-sm-5"
  }, [_c('input', {
    staticClass: "input input-sm",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.detail.display
    },
    on: {
      "click": function($event) {
        _vm.openByDrop($event, _vm.detail)
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.detail.show) ? _c('div', {
    staticClass: "calendar-dropdown",
    style: ({
      'left': _vm.detail.left + 'px',
      'top': _vm.detail.top + 'px'
    })
  }, [_c('calendar', {
    attrs: {
      "range": _vm.detail.range,
      "zero": _vm.detail.zero,
      "lunar": _vm.detail.lunar,
      "value": _vm.detail.value,
      "begin": _vm.detail.begin,
      "end": _vm.detail.end
    },
    on: {
      "select": _vm.detail.select,
      "rangeStart": _vm.detail.rangeStart
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-sm-2 n-p-l"
  }, [_c('div', {
    staticClass: "btn btn-info btn-sm",
    on: {
      "click": _vm.buildDetail
    }
  }, [_vm._v("查询")])])])])])]), _vm._v(" "), (_vm.detail.post !== '-1') ? _c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.detail.abilities), function(ability) {
    return _c('div', {
      key: ability._id,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12 col-sm-2 text-right",
      staticStyle: {
        "height": "50px",
        "line-height": "50px"
      }
    }, [_vm._v("\n                  " + _vm._s(ability.name) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-8"
    }, [_c('range-slider', {
      staticClass: "row",
      attrs: {
        "max": ability.max,
        "min": ability.min,
        "type": ability.type,
        "name": ability.name,
        "id": ability._id
      },
      on: {
        "change": _vm.detail.rangeChange
      },
      model: {
        value: (ability.range),
        callback: function($$v) {
          ability.range = $$v
        },
        expression: "ability.range"
      }
    })], 1)])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-border",
    staticStyle: {
      "table-layout": "fixed"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "32px"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', [_vm._v("姓名")]), _vm._v(" "), _c('th', [_vm._v("联系方式")]), _vm._v(" "), (_vm.detail.post === '-1') ? _c('th', [_vm._v("岗位")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "sort-th",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.sort(1)
      }
    }
  }, [_c('span', {
    staticClass: "sort"
  }, [_c('i', {
    staticClass: "fa",
    class: {
      'fa-angle-up': _vm.detail.score_sort != 1, 'fa-caret-up': _vm.detail.score_sort === 1
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa",
    class: {
      'fa-angle-down': _vm.detail.score_sort != -1, 'fa-caret-down': _vm.detail.score_sort === -1
    }
  })]), _vm._v("\n                        综合得分")]), _vm._v(" "), _vm._l((_vm.detail.view_abilities), function(ability, k1) {
    return _c('th', {
      key: k1,
      staticClass: "sort-th",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.sort(ability, _vm.detail.view_abilities)
        }
      }
    }, [_c('span', {
      staticClass: "sort"
    }, [_c('i', {
      staticClass: "fa",
      class: {
        'fa-angle-up': ability.sort != 1, 'fa-caret-up': ability.sort === 1
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa",
      class: {
        'fa-angle-down': ability.sort != -1, 'fa-caret-down': ability.sort === -1
      }
    })]), _vm._v(_vm._s(ability.name) + "\n                      ")])
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("操作")])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.detail.view_reports), function(report, ind) {
    return _c('tr', {
      key: report._id
    }, [_c('td', [_vm._v(_vm._s(_vm.detail.start + ind + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(report.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(report.phone || report.email))]), _vm._v(" "), (_vm.detail.post === '-1') ? _c('td', [_vm._v(_vm._s(report.questionnaire.name))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(report.abilities_score.toFixed(2)))]), _vm._v(" "), _vm._l((_vm.detail.view_abilities), function(ability, k1) {
      return _c('td', {
        key: k1
      }, [_vm._v("\n                        " + _vm._s(report.show_abilities[k1] ? report.show_abilities[k1].score.toFixed(2) : '-') + "\n                      ")])
    }), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn  btn-primary btn-xs",
      attrs: {
        "to": {
          'name': 'EvaluateReport',
          params: {
            'code': report._id
          }
        },
        "target": "_blank"
      }
    }, [_vm._v("报告")]), _vm._v(" "), (_vm.selectPost === '-1' || _vm.selectPost === report.questionnaire._id) ? _c('a', {
      staticClass: "btn btn-xs btn-info",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.addCompareResume(report)
        }
      }
    }, [_vm._v("对比")]) : _vm._e()], 1)], 2)
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('pagination', {
    attrs: {
      "current": _vm.detail.current,
      "length": 20,
      "total": _vm.detail.reports.length,
      "page-click": _vm.go
    }
  })], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 title"
  }, [_vm._v("数据总量")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12  title"
  }, [_vm._v("每日新增")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "350px"
    },
    attrs: {
      "id": "daily-trend-line-charts"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51cbd060","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/dashboard.vue
// module id = 479
// module chunks = 1